import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from '../../Core/services/language.service';
import { SessionService } from '../../Core/services/session.service';
import { AuthDataService } from '../../auth/auth-data.service';
import { ActivityTrackingComponent } from 'src/app/Core/activity-tracking/activity-tracking.component';
import { BackendService } from 'src/app/Core/services/backend.service';
import { environment } from 'src/environments/environment';
import { DeviceService } from 'src/app/Core/services/device.service';
import { DownloadBaseetaService } from 'src/app/Core/services/download-baseeta.service';
import { GtmService } from 'src/app/Core/services/gtm.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent extends ActivityTrackingComponent implements OnInit {
  showNotice = true;
  showAside = false;
  showModal = false;
  productId: any;
  showMenu = false;
  activeChild = 'home';
  snbLogoPath = 'assets/images/snb-logo.svg';
  baseetaAppQRCode : string = environment.baseetaAppQRCode;
  isMobile: boolean = false;
  
  constructor(
    private languageService: LanguageService,
    private session: SessionService,
    router: Router, backend : BackendService,
    private authDate: AuthDataService,
    private activatedRoute: ActivatedRoute, 
    private deviceService : DeviceService,
    private downloadBaseeta : DownloadBaseetaService,
    private gtmService: GtmService
  ) {
    super(backend, router);
    this.isMobile = this.deviceService.isMobile();
    session.assignReferrer();
    this.setPageName('landing');
  }

  override ngOnInit(): void {
    super.ngOnInit();
    sessionStorage.clear();
    const sid = this.activatedRoute.snapshot.paramMap.get("sid");
    console.log(sid);
    if (sid) {
      // sid is numeric
      if (!isNaN(parseInt(sid))) {
        sessionStorage.setItem('storeID', sid);
        sessionStorage.setItem('referrer', "Branch-" + sid);
        SessionService.disableGoogleTag();
        console.log(sessionStorage.getItem('referrer'));
        return;
      }
    }

    this.authDate.reload();
  }

  get isLeft() {
    return this.languageService.CurrentLang.IsLeft;
  }

  get token() {
    return this.session.token;
  }

  apply(productId: number) {

    if (productId == 2 || productId == 4) {
      sessionStorage.setItem('productId', String(productId))
      this.gtmService.pushEvent('applyNow_CTA', false, {
        'button_name': 'Apply Now',
        'button_location': this.showModal ? 'pop-up' : 'product_card',
        'product_name': productId == 2 ? 'Personal Finance' : 'Credit Cards'
      });
    }

    this.showModal = false;
    console.log(productId);
    sessionStorage.setItem('productId', productId.toString());
    sessionStorage.setItem('journeyTrackingId', this.generateGuidService.generateGUID());

    this.router.navigate(['/apply'], {
      queryParams: { 
        lang : this.languageService.CurrentLang.Name, 
        prod : productId.toString() 
      }
    });
  }

  downloadApp(){
    this.downloadBaseeta.downloadApp();
  }

  toggleLang() {
    this.languageService.toggle();
    location.reload();
  }

  login() {
    this.router.navigate(['civil']);
  }

  goToReferenceSignIn(): void {
    this.apply(2);
    this.router.navigate(['/auth/sign-in-using-reference-number']);
  }
}
